import _ from 'lodash';
import { createSelector } from 'reselect';

import { alphabeticalOptionsSort } from './utils';
import { getFormData, getTranslations } from '../../form-designer/selectors/common.selectors';
import { translate } from '../../form-designer/utils/form-manager.utils';

export const getWorkflowActionsAndTasks = createSelector(
  getFormData,
  (data) => data.workflowActionAndTask ?? {}
);

export const getOtherTasks = createSelector(
  getWorkflowActionsAndTasks,
  getTranslations,
  (workflowActionAndTask, translations) => {
    const { workflowTasks = [] } = workflowActionAndTask;
    const actions = _.flattenDeep(workflowTasks.map((wT) => wT.action ?? []));
    const actionItems = _.flattenDeep(actions.map((a) => a.actionItem ?? []));

    const actorCode = localStorage.getItem('actorCode');
    const [myTasks, otherTasks] = _.partition(actionItems, (item) => item.actorCode === actorCode);
    const myTasksGroupHeader = {
      id: 'My Tasks Header',
      translatedText: translate(translations, 'My Tasks'),
      isGroupHeader: true,
      isGroupEmpty: myTasks.length === 0,
      toolTip: '',
    };
    const otherTasksGroupHeader = {
      id: 'Other Tasks Header',
      translatedText: translate(translations, 'Other Tasks'),
      isGroupHeader: true,
      isGroupEmpty: otherTasks.length === 0,
      toolTip: '',
    };

    if (myTasks.length === 0 && otherTasks.length === 0) {
      return [];
    }

    const myTasksResult = [myTasksGroupHeader].concat(myTasks.sort(alphabeticalOptionsSort));
    const otherTasksResult = [otherTasksGroupHeader].concat(
      otherTasks.sort(alphabeticalOptionsSort)
    );

    return myTasksResult.concat(otherTasksResult);
  }
);

export const getWorkflowActions = createSelector(
  getWorkflowActionsAndTasks,
  (workflowActionAndTask) => workflowActionAndTask.workflowActions ?? []
);

export const getOtherActions = createSelector(getWorkflowActions, (workflowActions) =>
  _.flattenDeep(workflowActions.map((wA) => wA.actions ?? []))
);
